<template>
    <div class="change-channel-type">
        <v-row class="ma-0 mb-4 header-row" align="center">
            <v-btn icon class="mr-2 back-btn" @click="$emit('back')">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <h2 class="dashboard">Изменение типа канала</h2>
        </v-row>
        <div class="mb-2 change-channel-type__hint">
            Выберите канал
        </div>
        <div class="channel-type-list">
            <div
                v-for="ch in channelTypeOptions"
                :key="ch.id"
                class="channel-type-item"
                :class="{ 'channel-type-item--selected': selectedGroupId === ch.id }"
                @click="selectedGroupId = ch.id"
            >
                <v-avatar :color="ch.avatarColor" size="36">
                    <v-img v-if="ch.avatarImage" :src="ch.avatarImage" />
                    <span v-else class="white--text" style="font-size: 14px; font-weight: 600;">{{ ch.avatarSymbol }}</span>
                </v-avatar>
                <span class="channel-type-item__name">{{ ch.name }}</span>
                <v-icon
                    :color="selectedGroupId === ch.id ? '#378EFF' : '#AAB1B9'"
                    size="20"
                    class="ml-auto"
                >
                    {{ selectedGroupId === ch.id ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                </v-icon>
            </div>
        </div>
        <div v-if="shouldShowDisconnectWarning" class="warning-text-wrapper mt-4">
            <div class="d-flex align-center mb-1">
                <img class="mr-1 mb-1" style="width: 16px; height: 16px;" src="@/assets/icons/error-status.svg" />
                <strong class="description-text-wrapper__warning">Важно!</strong>
            </div>
            <p class="description-text-wrapper__text">
                При смене типа канала, номер {{ channelPhone }}, который сейчас подключен к {{ channelDisplayName }},
                будет отключен. Отправка с этого номера прекратится.
            </p>
        </div>
        <v-checkbox
            v-if="shouldShowDisconnectWarning"
            v-model="isUnderstood"
            class="change-channel-type__checkbox ma-0 mt-4"
            hide-details
            color="mainNew"
            label="Я понимаю, что изменяемый канал будет отключен"
        />
        <div class="change-channel-type__actions mt-4">
            <v-btn outlined class="outlined-btn" @click="$emit('back')">
                Назад
            </v-btn>
            <v-spacer />
            <v-btn
                color="mainNew"
                class="white--text"
                :disabled="!selectedGroupId || (shouldShowDisconnectWarning && !isUnderstood)"
                @click="$emit('continue', selectedGroupId)"
            >
                Далее
            </v-btn>
        </div>
    </div>
</template>

<script>
import whatsappLogo from '@/assets/img/messenger-logo/wa-logo.png'
import telegramLogo from '@/assets/img/messenger-logo/telegram-logo.png'
import maxLogo from '@/assets/img/messenger-logo/max-logo.png'

export default {
    name: 'ChangeChannelTypeSidebarContent',
    emits: ['back', 'continue'],
    props: {
        channelDisplayName: {
            type: String,
            default: '',
        },
        channelPhone: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            selectedGroupId: null,
            isUnderstood: false,
        }
    },
    computed: {
        channelTypeOptions() {
            return [
                { id: 'whatsapp', name: 'WhatsApp', avatarColor: '#29a71a', avatarImage: whatsappLogo, avatarSymbol: null },
                { id: 'telegram', name: 'Telegram', avatarColor: '#24aaeb', avatarImage: telegramLogo, avatarSymbol: null },
                { id: 'max', name: 'MAX', avatarColor: '#3b47ec', avatarImage: maxLogo, avatarSymbol: null },
                { id: 'sms', name: 'SMS', avatarColor: '#43A047', avatarImage: null, avatarSymbol: 'SMS' },
            ]
        },
        shouldShowDisconnectWarning() {
            return Boolean(this.channelPhone)
        },
    },
}
</script>

<style lang="sass" scoped>
.change-channel-type

.header-row
    padding: 0 0 16px 0
    border-bottom: 1px solid #E1E8ED
    margin-bottom: 20px !important

h2.dashboard
    font-weight: 600 !important
    font-size: 20px !important
    color: #2A3B51
    margin-bottom: 0 !important
    letter-spacing: -0.3px

.back-btn
    color: #378EFF !important
    transition: all 0.2s ease

    &:hover
        background-color: rgba(55, 142, 255, 0.08) !important
        transform: translateX(-2px)

.change-channel-type__hint
    font-size: 14px
    color: #2A3B5199

.channel-type-list
    display: flex
    flex-direction: column
    gap: 8px

.channel-type-item
    display: flex
    align-items: center
    gap: 12px
    padding: 12px 16px
    border-radius: 8px
    border: 1px solid #E1E8ED
    cursor: pointer
    transition: all 0.15s ease
    overflow: hidden
    height: 60px

    &:hover
        border-color: #378EFF
        background: rgba(55, 142, 255, 0.04)

    &--selected
        border-color: #378EFF
        background: rgba(55, 142, 255, 0.06)

.channel-type-item__name
    font-size: 15px
    font-weight: 500
    color: #2A3B51

.change-channel-type__checkbox
    margin-left: -8px

.warning-text-wrapper
    background: #FFF3E0 0% 0% no-repeat padding-box
    border: 1px solid #FFE0B2
    border-radius: 8px
    padding: 12px 16px
    margin-bottom: 16px
    overflow: hidden

.description-text-wrapper__warning
    font: normal normal 600 14px/20px Geologica
    letter-spacing: 0px
    color: #F57C00

.description-text-wrapper__text
    font: normal normal normal 14px/16px Geologica
    letter-spacing: 0px
    color: #2A3B51DE
    margin-bottom: 0

.change-channel-type__actions
    display: flex
    justify-content: flex-end
    gap: 8px
</style>
